import React, { FC, useState } from "react";
import SkeletonLoader from "../../../components/common/SkeletonLoader";
import { useGetOrderToDoListQuery, useRemoveToDoMutation, useUpdateToDoCompletionStatusMutation } from "../productsApi";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import AuditableInfo from "../../../components/common/AuditableInfo";
import ModalButton from "../../../components/common/form/ModalButton";
import { FaEdit, FaPencilAlt, FaPencilRuler, FaTrash, } from "react-icons/fa";
import { FaCirclePlus, FaPen, FaPencil, FaPersonCircleCheck } from "react-icons/fa6";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { getActionTextForCard } from "../../../helpers/utils/Utils";
import AddOrUpdateToDoTask from "../modal/AddOrUpdateToDoTask";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";

interface props {
    productId?: string
}

const OrderToDoList: FC<props> = () => {

    const [disable, setDisable] = useState(false);
    const { orderId } = useParams();
    const [showAddToDoModal, setShowAddToDoModal] = useState(false);

    const [toDoObject, setToDoObject] = useState(null);

    const {
        data: orderNotes,
        isLoading: loading,
        isError: error,
    } = useGetOrderToDoListQuery(orderId || skipToken);
    const [updateStatatus, { isLoading }] = useUpdateToDoCompletionStatusMutation()
    const [removeToDo] = useRemoveToDoMutation();



    const iconButtonStyle = "cursor-pointer !text-highlight-0 text-lg";

    const updateToDoCompletionStatus = (toDoId: any) => (e: any) => {
        e.preventDefault();
        updateStatatus(toDoId);
        setDisable(!disable)
    };

    const handleDelete = async (todoId: string) => {
        if (todoId) {
            return await removeToDo(todoId).unwrap();
        }
    };

    return (
        <>
            <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md  mb-2">
                <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                    <h5 className="font-semibold text-surface-0">To do List ({orderNotes?.length})</h5>
                    {hasPermission(["TODO-C"]) &&
                        <ModalButton
                            triggerButton={<FaCirclePlus size={14}
                                title={"To-Do Task"} className="text-highlight-5 text-lg" />}
                            modal={
                                <AddOrUpdateToDoTask title={"Add To-Do Task"} show={showAddToDoModal}
                                    setShow={setShowAddToDoModal}
                                    todoObj={toDoObject} btnName={"Add"} />
                            }
                        />}


                </div>
                <div className='p-2'>
                    {
                        (loading) ?
                            <SkeletonLoader className={"mt-2"} count={3}></SkeletonLoader> :
                            !error && orderNotes?.length === 0 ?
                                <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                    <h3 className="text-surface-0">
                                        No To-do tasks to display
                                    </h3>
                                </div>
                                :

                                <div className={"overflow-y-auto max-h-32"}>
                                    {!error && orderNotes && orderNotes?.map((data: any) => {
                                        return <div className="border-2 border-[rgba(0,0,0,0.1)]  rounded-sm bg-text-0">
                                            <div className={data.completed === false ? "bg-[white] grid-cols-12 lg:grid sm:block p-3" : "p-4 grid-cols-12 lg:grid sm:block bg-[#DDDDDD]"}>
                                                <div className="col-span-6">
                                                    <div className={"d-flex gap-3"}>
                                                        <input
                                                            type="checkbox"
                                                            checked={data.completed}
                                                            onChange={updateToDoCompletionStatus(data.id)}
                                                            className={"todo_check"}

                                                        />
                                                        <span>{data?.description}</span>
                                                    </div>
                                                    <div className="flex gap-2 items-center mt-2">
                                                        {hasPermission(["TODO-D"]) &&
                                                            <div className={"text-lg ml-5 "}>

                                                                <ModalButton
                                                                    triggerButton={<FaTrash size={14} className={iconButtonStyle}
                                                                        title={"Delete To-Do Task"} />}
                                                                    modal={
                                                                        <ConfirmationModal
                                                                            show={true}
                                                                            setShow={() => {
                                                                            }}
                                                                            title={"Remove To-Do task"}
                                                                            bodyMessage={"Are you sure you want to remove this task?"}
                                                                            onSubmit={() => handleDelete(data.id)}
                                                                            isLoading={isLoading}
                                                                        />
                                                                    }
                                                                />
                                                            </div>}
                                                        {hasPermission(["TODO-U"]) &&
                                                            <ModalButton
                                                                triggerButton={
                                                                    <FaEdit size={18}
                                                                        className={`${iconButtonStyle} text-surface-0 rounded-md`} />}
                                                                onOpen={() => {

                                                                    setToDoObject(data);
                                                                }}
                                                                modal={
                                                                    <AddOrUpdateToDoTask title={"Update To-Do Task"} show={showAddToDoModal}
                                                                        setShow={setShowAddToDoModal}
                                                                        todoObj={toDoObject} btnName={"Update"} />
                                                                }
                                                            />

                                                        }

                                                    </div>
                                                </div>
                                                <div className="col-span-6 text-sm flex flex-col items-end text-text-2">
                                                    <div className="text-left">
                                                        <AuditableInfo data={data} />

                                                        {data.completed && <div className="col-span-6 text-sm text-text-2 text-sm">
                                                            {getActionTextForCard("Completed", "", data.completedDate)}
                                                        </div>
                                                        }

                                                        {data.followUpDate && <div className="col-span-6 text-sm text-text-2 text-sm">
                                                            {getActionTextForCard("Follow-up", "", data.followUpDate)}
                                                        </div>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    })}
                                </div>

                    }
                </div>


            </div>


        </>
    )
}

export default OrderToDoList;